import type { ContentArtifactType } from './ContentArtifactCard.tsx';

const SL = '#DDE1E8';
const FL = '#F0F3F7';
const F = '#E8ECF2';
const S = '#C4CAD4';
const A = '#2563EB';

const ContentApprovalIllustration = () => (
	<svg width="130" height="96" viewBox="0 0 130 96" fill="none">
		{[0, 1, 2, 3, 4, 5].map((n) => {
			const col = n % 3;
			const row = Math.floor(n / 3);
			const x = 6 + col * 41;
			const y = 4 + row * 46;
			const hasCheck = n === 0 || n === 1 || n === 3;
			const isPending = n === 2 || n === 4;
			return (
				<g key={n}>
					<rect
						x={x}
						y={y}
						width="37"
						height="40"
						rx="5"
						fill={isPending ? 'white' : FL}
						stroke={isPending ? A : SL}
						strokeWidth={isPending ? '1.2' : '1'}
						style={
							isPending
								? { filter: 'drop-shadow(0 1px 4px rgba(37,99,235,0.08))' }
								: undefined
						}
					/>
					<rect
						x={x + 5}
						y={y + 5}
						width="27"
						height="18"
						rx="3"
						fill={isPending ? 'rgba(37,99,235,0.06)' : F}
					/>
					<rect
						x={x + 5}
						y={y + 27}
						width="20"
						height="2.5"
						rx="1"
						fill={isPending ? 'rgba(37,99,235,0.15)' : SL}
					/>
					<rect
						x={x + 5}
						y={y + 32}
						width="14"
						height="2.5"
						rx="1"
						fill={isPending ? 'rgba(37,99,235,0.08)' : SL}
						opacity="0.5"
					/>
					{hasCheck && (
						<g>
							<circle
								cx={x + 31}
								cy={y + 6}
								r="5"
								fill="#10B981"
								opacity="0.85"
							/>
							<path
								d={`M${x + 28.5} ${y + 6}L${x + 30} ${y + 7.5}L${x + 33.5} ${y + 4}`}
								stroke="white"
								strokeWidth="1.2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</g>
					)}
					{n === 5 && (
						<g>
							<line
								x1={x + 18.5}
								y1={y + 14}
								x2={x + 18.5}
								y2={y + 26}
								stroke={S}
								strokeWidth="1.3"
								strokeLinecap="round"
							/>
							<line
								x1={x + 12.5}
								y1={y + 20}
								x2={x + 24.5}
								y2={y + 20}
								stroke={S}
								strokeWidth="1.3"
								strokeLinecap="round"
							/>
						</g>
					)}
				</g>
			);
		})}
	</svg>
);

const EmailIllustration = () => (
	<svg width="130" height="100" viewBox="0 0 130 100" fill="none">
		<g transform="translate(38, 8) rotate(3)">
			<rect
				width="54"
				height="38"
				rx="5"
				fill="#F0F3F7"
				stroke={SL}
				strokeWidth="1"
			/>
			<path d="M2 6L27 24L52 6" stroke={SL} strokeWidth="1" fill="none" />
		</g>
		<g transform="translate(32, 18) rotate(-1.5)">
			<rect
				width="58"
				height="40"
				rx="5"
				fill="white"
				stroke={SL}
				strokeWidth="1.1"
			/>
			<path
				d="M2 6L29 26L56 6"
				stroke={S}
				strokeWidth="0.8"
				fill="none"
				opacity="0.4"
			/>
			<rect x="10" y="28" width="22" height="2.5" rx="1" fill={SL} />
			<rect
				x="10"
				y="33"
				width="14"
				height="2.5"
				rx="1"
				fill={SL}
				opacity="0.5"
			/>
		</g>
		<g transform="translate(26, 30)">
			<rect
				width="62"
				height="44"
				rx="6"
				fill="white"
				stroke={S}
				strokeWidth="1.2"
				style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.03))' }}
			/>
			<path d="M2 7L31 28L60 7" stroke={S} strokeWidth="1.1" fill="none" />
			<rect
				x="12"
				y="30"
				width="26"
				height="2.5"
				rx="1"
				fill={S}
				opacity="0.25"
			/>
			<rect
				x="12"
				y="36"
				width="18"
				height="2.5"
				rx="1"
				fill={SL}
				opacity="0.6"
			/>
		</g>
		<circle
			cx="90"
			cy="28"
			r="9"
			fill="white"
			style={{ filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.05))' }}
		/>
		<circle cx="90" cy="28" r="7" fill={A} />
		<text
			x="90"
			y="31"
			textAnchor="middle"
			fill="white"
			fontSize="8"
			fontWeight="700"
			fontFamily="sans-serif"
		>
			3
		</text>
		<path
			d="M102 62Q114 62 114 52Q114 42 102 42"
			stroke={S}
			strokeWidth="1.1"
			fill="none"
			strokeLinecap="round"
		/>
		<path
			d="M105 46L102 42L105 38"
			stroke={S}
			strokeWidth="1.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const ReplyApprovalIllustration = () => (
	<svg width="140" height="96" viewBox="0 0 140 96" fill="none">
		<rect
			x="6"
			y="16"
			width="44"
			height="32"
			rx="7"
			fill={FL}
			stroke={SL}
			strokeWidth="1.1"
		/>
		<path
			d="M16 48L12 54L24 48"
			fill={FL}
			stroke={SL}
			strokeWidth="1.1"
			strokeLinejoin="round"
		/>
		<circle cx="14" cy="10" r="4.5" fill={FL} stroke={SL} strokeWidth="1" />
		<rect x="14" y="26" width="24" height="2.5" rx="1" fill={S} opacity="0.4" />
		<rect
			x="14"
			y="32"
			width="16"
			height="2.5"
			rx="1"
			fill={SL}
			opacity="0.5"
		/>
		<rect
			x="86"
			y="14"
			width="48"
			height="36"
			rx="7"
			fill="white"
			stroke={A}
			strokeWidth="1.2"
			style={{ filter: 'drop-shadow(0 2px 6px rgba(37,99,235,0.06))' }}
		/>
		<rect
			x="94"
			y="23"
			width="26"
			height="2.5"
			rx="1"
			fill={A}
			opacity="0.15"
		/>
		<rect x="94" y="29" width="18" height="2.5" rx="1" fill={A} opacity="0.1" />
		<rect
			x="94"
			y="36"
			width="22"
			height="8"
			rx="3.5"
			fill={A}
			opacity="0.12"
		/>
		<rect x="98" y="39" width="14" height="2" rx="1" fill={A} opacity="0.25" />
		<circle
			cx="130"
			cy="18"
			r="7"
			fill="white"
			style={{ filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.06))' }}
		/>
		<circle cx="130" cy="18" r="5.5" fill="#10B981" opacity="0.85" />
		<path
			d="M128 18L129.2 19.3L132 16.5"
			stroke="white"
			strokeWidth="1.2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<rect
			x="6"
			y="60"
			width="40"
			height="26"
			rx="6"
			fill={FL}
			stroke={SL}
			strokeWidth="0.8"
			opacity="0.6"
		/>
		<rect x="14" y="68" width="20" height="2.5" rx="1" fill={S} opacity="0.3" />
		<rect
			x="14"
			y="74"
			width="14"
			height="2.5"
			rx="1"
			fill={SL}
			opacity="0.3"
		/>
		<circle cx="68" cy="36" r="1.5" fill={SL} />
		<circle cx="72" cy="36" r="1.5" fill={SL} opacity="0.6" />
	</svg>
);

const ILLUSTRATION: Record<ContentArtifactType, React.FC> = {
	post: ContentApprovalIllustration,
	digital_ad: ContentApprovalIllustration,
	email_html: EmailIllustration,
	email_plaintext: EmailIllustration,
	ig_comment_reply: ReplyApprovalIllustration,
};

export const ContentArtifactIllustration = ({
	type,
}: {
	type: ContentArtifactType;
}) => {
	const Component = ILLUSTRATION[type];
	return <Component />;
};
